import axios from 'axios'
import { REACT_APP_PERITADOR_API } from 'cfgCommon/config'

export async function getCanDelete(requestsId) {
  const response = await axios(
    `${REACT_APP_PERITADOR_API}/takingCarManagment/canDelete?requestsId=${requestsId}`
  )

  return response.data
}
